
import React, { useState } from 'react';
import'../style/Contact.css'

export const Contact = () => {
 
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  return (
    <div className="contact-container">
      <h1>Bizimle İletişime Geçin</h1>
      <form
        className="contact-form"
        action="https://formspree.io/f/{YOUR_FORM_ID}" // Formspree form ID'nizi buraya ekleyin
        method="POST"
      >
        <label htmlFor="name">Adınız:</label>
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
        />

        <label htmlFor="email">E-posta Adresiniz:</label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
        />

        <label htmlFor="message">Mesajınız:</label>
        <textarea
          id="message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          required
        />

        <button type="submit">Gönder</button>
      </form>
    </div>
  );

}
